import { Component, OnInit } from '@angular/core'
import { AuthenticationService } from '../../../_services/authentication.service'
import { RequestsService } from '../../../_shared/services/requests.service'
import { FormGroup, Validators, FormBuilder, FormArray } from '@angular/forms'
import { HelperFunctions } from '../../../_shared/utils/helper-functions'

declare var jQuery: any

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.scss'],
})
export class ContactsComponent implements OnInit {
  addContactForm: FormGroup

  constructor(
    private authenticationService: AuthenticationService,
    private requestService: RequestsService,
    private fb: FormBuilder,
    private helperFunctions: HelperFunctions
  ) {}

  message: string
  countryName: string
  agroPage = 1
  count = 10
  model: any
  loading: boolean
  status: string
  searchItem: string
  isLoadingContacts: boolean
  contactsData: any
  isAddingContact: boolean
  isDeletingContact: boolean
  isEditingContact: boolean
  contactId: string
  singleAgronomistsViewData: any
  states: any
  selectedState: string
  salesManagersData: any
  agronomistsData: any
  statesDistrictsData: any
  selectItems: any
  indiaStates: any
  ugandaDistricts: any
  agroIndex: string
  salesIndex: string
  districtsToSelect: any
  singleSalesMngrData: any
  statePicked: string
  selectedItems: any
  contactStates: any
  districtSubcountyData: any
  districtPicked: string
  subcountiesToSelect: any
  selectedDistrict: string
  districts: any

  ngOnInit() {
    const currentUser = this.authenticationService.getCurrentUserValue()
    const { country } = currentUser
    this.countryName = country
    this.model = {}
    let stateValue =
      this.countryName === 'India' ? ['', Validators.required] : ''
    let districtValue =
      this.countryName === 'Uganda' ? ['', Validators.required] : ''

    this.addContactForm = this.fb.group({
      state: stateValue,
      district: districtValue,
      agronomist: this.fb.array([]),
      customer_service: this.fb.array([]),
    })
    this.loadContacts()
    this.loadIndiaStates()
    this.loadStatesDistricts()
    this.loadUgandaDistricts()
  }

  get state(): any {
    return this.addContactForm.get('state')
  }

  addAgronomist(): FormArray {
    return this.addContactForm.get('agronomist') as FormArray
  }

  newAgronomist(): FormGroup {
    return this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^\+?\d{1,15}$/)]],
      whatsapp: ['', Validators.pattern(/^\+?\d{1,15}$/)],
    })
  }

  addNewAgronomist() {
    this.addAgronomist().push(this.newAgronomist())
  }

  removeAgronomist(index) {
    this.addAgronomist().removeAt(index)
  }

  addSalesMngr(): FormArray {
    return this.addContactForm.get('customer_service') as FormArray
  }

  newSalesMngr(): FormGroup {
    let districtValue =
      this.countryName === 'India'
        ? [{ value: [], disabled: !this.statePicked }]
        : [[]]
    let subCountyValue =
      this.countryName === 'Uganda'
        ? [{ value: [], disabled: !this.districtPicked }]
        : [[]]

    return this.fb.group({
      name: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', [Validators.required, Validators.pattern(/^\+?\d{1,15}$/)]],
      whatsapp: ['', Validators.pattern(/^\+?\d{1,15}$/)],
      district: districtValue,
      sub_county: subCountyValue,
    })
  }

  addNewSalesMngr() {
    this.addSalesMngr().push(this.newSalesMngr())
  }

  removeSalesMngr(index) {
    this.addSalesMngr().removeAt(index)
  }

  openCity(evt, cityName) {
    // Declare all variables
    var i, tabcontent, tablinks

    // Get all elements with class="tabcontent" and hide them
    tabcontent = document.getElementsByClassName('tabcontent')
    for (i = 0; i < tabcontent.length; i++) {
      tabcontent[i].style.display = 'none'
    }

    // Get all elements with class="tablinks" and remove the class "active"
    tablinks = document.getElementsByClassName('tab-link')
    for (i = 0; i < tablinks.length; i++) {
      tablinks[i].className = tablinks[i].className.replace('active', '')
    }

    // Show the current tab, and add an "active" class to the link that opened the tab
    document.getElementById(cityName).style.display = 'block'
    evt.currentTarget.className += ' active'
  }

  loadContacts(): void {
    this.isAddingContact || this.isDeletingContact || this.isEditingContact
      ? (this.isLoadingContacts = false)
      : (this.isLoadingContacts = true)

    this.requestService.dash_get(`contact/${this.countryName}`, null).subscribe(
      (res) => {
        this.isLoadingContacts = false
        this.contactsData = res.data
        let states = []
        let districts = []
        let contactId = ''
        let agronomists = []
        let salesExecutives = []

        this.contactsData
          ? this.contactsData.map((each) => {
              if (this.countryName === 'India') {
                each.state ? states.push(each.state) : null

                this.states = Array.from(new Set(states))
                !this.selectedState
                  ? (this.selectedState = this.states[0])
                  : null

                this.selectedState === each.state
                  ? ((salesExecutives = each.customer_service),
                    (agronomists = each.agronomist),
                    (contactId = each.id))
                  : null
              } else if (this.countryName === 'Uganda') {
                each.district ? districts.push(each.district) : null

                this.districts = Array.from(new Set(districts))
                !this.selectedDistrict
                  ? (this.selectedDistrict = this.districts[0])
                  : null

                this.selectedDistrict === each.district
                  ? ((salesExecutives = each.customer_service),
                    (agronomists = each.agronomist),
                    (contactId = each.id))
                  : null
              }
            })
          : null
        this.salesManagersData = salesExecutives
        this.agronomistsData = agronomists
        this.contactId = contactId
      },
      (err) => {
        this.isLoadingContacts = false
        this.message = err.error
      }
    )
  }

  setSelectDistricts() {
    this.statesDistrictsData
      ? this.statesDistrictsData.map((each) => {
          let districts = []
          if (each.state === this.selectedState) {
            each.districts
              ? each.districts.map((each) => {
                  districts.push({ label: each, value: each })
                  this.districtsToSelect = districts
                })
              : null
          }
        })
      : null

    this.districtSubcountyData
      ? this.districtSubcountyData.map((each) => {
          let subCounties = []
          if (each.district === this.selectedDistrict) {
            each.subcounty
              ? each.subcounty.map((each) => {
                  subCounties.push({ label: each, value: each })
                  this.subcountiesToSelect = subCounties
                })
              : null
          }
        })
      : null
  }

  onStateOptionSelected(event: any) {
    this.selectedState = event.target.value

    this.contactsData
      ? this.contactsData.map((each) => {
          this.selectedState === each.state
            ? ((this.salesManagersData = each.customer_service),
              (this.agronomistsData = each.agronomist),
              (this.contactId = each.id))
            : null
        })
      : null
  }

  onDistrictOptionSelected(event: any) {
    this.selectedDistrict = event.target.value

    this.contactsData
      ? this.contactsData.map((each) => {
          this.selectedDistrict === each.district
            ? ((this.salesManagersData = each.customer_service),
              (this.agronomistsData = each.agronomist),
              (this.contactId = each.id))
            : null
        })
      : null
  }

  addContacts() {
    const formData = new FormData()

    formData.append('state', this.addContactForm.value.state)
    formData.append('district', this.addContactForm.value.district)
    formData.append(
      'agronomist',
      JSON.stringify(this.addContactForm.value.agronomist)
    )
    formData.append(
      'customer_service',
      JSON.stringify(this.addContactForm.value.customer_service)
    )

    this.loading = true

    this.requestService
      .dash_post(`contact/${this.countryName}`, formData)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAddingContact = true
            this.loadContacts()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeAddContactModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeAddContactModal() {
    jQuery(document).ready(() => {
      jQuery('#addContactModal').modal('hide')
      jQuery('#addContactForm')[0].reset()
      this.isAddingContact = false
      this.districtsToSelect = []
      this.statePicked = ''
      this.districtPicked = ''
      this.subcountiesToSelect = []
      this.addAgronomist().controls = []
      this.addSalesMngr().controls = []
    })
  }

  setSingleAgronomistsViewData(data: object, index: string) {
    this.singleAgronomistsViewData = data
    this.agroIndex = index
  }

  deleteContact(id: string): void {
    this.loading = true
    this.requestService.dash_delete(id, `contact`).subscribe(
      (res) => {
        this.loading = false
        if (res.success === true) {
          this.status = 'success'
          this.isDeletingContact = true
          this.loadContacts()
          this.message = res.message
          this.helperFunctions.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isDeletingContact = false
            jQuery('#deleteContactModal').modal('hide')
            this.selectedState = ''
            this.selectedDistrict = ''
          })
        } else if ((res.success = false)) {
          this.status = 'error'
          this.message = res.message
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      },
      (err) => {
        this.loading = false
        if (err.status === 404) {
          this.message = 'Contact not found!'
        } else {
          this.message = 'Some error occurred. Please try again'
          this.status = 'error'
          this.helperFunctions.displayAlert(this.message, this.status)
          jQuery(document).ready(() => {
            this.isDeletingContact = false
            jQuery('#deleteContactModal').modal('hide')
          })
        }
      }
    )
  }

  loadIndiaStates(): void {
    this.requestService.dash_get(`india/states`, null).subscribe(
      (res) => {
        let indiaStates = []
        res.data
          ? res.data.map((each) => {
              indiaStates.push(each.states)
              this.indiaStates = indiaStates
            })
          : null
      },
      (err) => {
        this.message = err.error
      }
    )
  }

  loadUgandaDistricts(): void {
    this.requestService.dash_get(`ug/districts`, null).subscribe(
      (res) => {
        this.districtSubcountyData = res.data
        let ugandaDistricts = []
        res.data
          ? res.data.map((each) => {
              ugandaDistricts.push(each.district)
              this.ugandaDistricts = ugandaDistricts
            })
          : null
      },
      (err) => {
        this.message = err.error
      }
    )
  }

  loadStatesDistricts(): void {
    this.requestService.dash_get(`states/district`, null).subscribe(
      (res) => {
        this.statesDistrictsData = res.data
        let contactStates = []
        this.statesDistrictsData
          ? this.statesDistrictsData.map((each) => {
              contactStates.push(each.state)
              this.contactStates = contactStates
            })
          : null
      },
      (err) => {
        this.message = err.error
      }
    )
  }

  onStateOptionChosen(event) {
    this.statePicked = event.target.value
    this.getSelectItems()
    this.addSalesMngr().controls = []
  }

  getSelectItems() {
    this.statesDistrictsData
      ? this.statesDistrictsData.map((each) => {
          let districts = []
          if (each.state === this.statePicked) {
            each.districts
              ? each.districts.map((each) => {
                  districts.push({ label: each, value: each })
                  this.districtsToSelect = districts
                })
              : null
          }
        })
      : null
  }

  addAgronomists(addAgronomistsForm) {
    const formData = new FormData()

    formData.append('agro_name', addAgronomistsForm.agro_name)
    formData.append('agro_phone', addAgronomistsForm.agro_phone)
    formData.append('agro_whatsapp', addAgronomistsForm.agro_whatsapp)
    formData.append('agro_email', addAgronomistsForm.agro_email)

    this.loading = true

    this.requestService
      .dash_post(`contact/agronomist/${this.contactId}`, formData)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAddingContact = true
            this.loadContacts()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeAddAgroContactModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeAddAgroContactModal() {
    jQuery(document).ready(() => {
      this.isAddingContact = false
      jQuery('#addAgronomistModal').modal('hide')
      jQuery('#addAgronomistForm')[0].reset()
    })
  }

  editAgronomists(editAgronomistsForm) {
    const formData = new FormData()

    formData.append('agro_name', editAgronomistsForm.agro_name)
    formData.append('agro_phone', editAgronomistsForm.agro_phone)
    formData.append('agro_whatsapp', editAgronomistsForm.agro_whatsapp)
    formData.append('agro_email', editAgronomistsForm.agro_email)

    this.loading = true

    this.requestService
      .dash_post(
        `contact/agronomist/update/${this.contactId}/${this.agroIndex}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isEditingContact = true
            this.loadContacts()
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              this.isEditingContact = false
              jQuery('#editAgronomistModal').modal('hide')
            })
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  deleteAgronomistContact(index: string): void {
    this.loading = true
    this.requestService
      .dash_delete(index, `contact/agronomist/update/${this.contactId}`)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.status = 'success'
            this.isDeletingContact = true
            this.loadContacts()
            this.message = res.message
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              this.isDeletingContact = false
              jQuery('#deleteAgronomistModal').modal('hide')
            })
          } else if ((res.success = false)) {
            this.status = 'error'
            this.message = res.message
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          if (err.status === 404) {
            this.message = 'Contact not found!'
          } else {
            this.message = 'Some error occurred. Please try again'
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              this.isDeletingContact = false
              jQuery('#deleteAgronomistModal').modal('hide')
            })
          }
        }
      )
  }

  setSingleSalesViewData(data: object, index: string) {
    let selectedDistricts = []
    let selectedSubcounties = []
    this.singleSalesMngrData = data
    this.salesIndex = index

    this.singleSalesMngrData.district
      ? this.singleSalesMngrData.district.map((each) => {
          selectedDistricts.push({ label: each, value: each })
          this.selectedItems = selectedDistricts
        })
      : null

    this.singleSalesMngrData.sub_county
      ? this.singleSalesMngrData.sub_county.map((each) => {
          selectedSubcounties.push({ label: each, value: each })
          this.selectedItems = selectedSubcounties
        })
      : null

    this.setSelectDistricts()
  }

  addSalesManager(addSalesManagerForm) {
    const formData = new FormData()
    let selectedDistricts: any = []
    let selectedSubcounties: any = []

    if (this.countryName === 'India') {
      this.selectedItems
        ? this.selectedItems.map((each) => {
            selectedDistricts.push(each.value)
          })
        : null
    } else if (this.countryName === 'Uganda') {
      this.selectedItems
        ? this.selectedItems.map((each) => {
            selectedSubcounties.push(each.value)
          })
        : null
    }

    formData.append('sales_name', addSalesManagerForm.sales_name)
    formData.append('sales_phone', addSalesManagerForm.sales_phone)
    formData.append('sales_whatsapp', addSalesManagerForm.sales_whatsapp)
    formData.append('sales_email', addSalesManagerForm.sales_email)
    formData.append('sales_district', selectedDistricts)
    formData.append('sub_county', selectedSubcounties)

    this.loading = true

    this.requestService
      .dash_post(`contact/salesmanager/${this.contactId}`, formData)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isAddingContact = true
            this.loadContacts()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeAddSalesContactModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeAddSalesContactModal() {
    jQuery(document).ready(() => {
      this.isAddingContact = false
      jQuery('#addSalesMngrModal').modal('hide')
      jQuery('#addSalesMngrForm')[0].reset()
      this.districtsToSelect = []
      this.subcountiesToSelect = []
      this.selectedItems = []
    })
  }

  editSalesManager(editSalesManagerForm) {
    const formData = new FormData()
    let selectedDistricts: any = []
    let selectedSubcounties: any = []

    if (this.countryName === 'India') {
      this.selectedItems
        ? this.selectedItems.map((each) => {
            selectedDistricts.push(each.value)
          })
        : null
    } else if (this.countryName === 'Uganda') {
      this.selectedItems
        ? this.selectedItems.map((each) => {
            selectedSubcounties.push(each.value)
          })
        : null
    }

    formData.append('sales_name', editSalesManagerForm.sales_name)
    formData.append('sales_phone', editSalesManagerForm.sales_phone)
    formData.append('sales_whatsapp', editSalesManagerForm.sales_whatsapp)
    formData.append('sales_email', editSalesManagerForm.sales_email)
    formData.append('sales_district', selectedDistricts)
    formData.append('sub_county', selectedSubcounties)

    this.loading = true

    this.requestService
      .dash_post(
        `contact/salesmanager/update/${this.contactId}/${this.salesIndex}`,
        formData
      )
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.message = res.message
            this.status = 'success'
            this.isEditingContact = true
            this.loadContacts()
            this.helperFunctions.displayAlert(this.message, this.status)
            this.closeEditSalesContactModal()
          } else if (res.success === false) {
            this.message = res.message
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          } else if (res.error) {
            this.message = res.error
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          this.status = 'error'
          this.message = 'An error occurred. Please try again'
          this.helperFunctions.displayAlert(this.message, this.status)
        }
      )
  }

  closeEditSalesContactModal() {
    jQuery(document).ready(() => {
      this.isEditingContact = false
      jQuery('#editSalesMngrModal').modal('hide')
      this.districtsToSelect = []
      this.selectedItems = []
      this.subcountiesToSelect = []
    })
  }

  deleteSalesMngrContact(index: string): void {
    this.loading = true
    this.requestService
      .dash_delete(index, `contact/salesmanager/update/${this.contactId}`)
      .subscribe(
        (res) => {
          this.loading = false
          if (res.success === true) {
            this.status = 'success'
            this.isDeletingContact = true
            this.loadContacts()
            this.message = res.message
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              this.isDeletingContact = false
              jQuery('#deleteSalesMngrModal').modal('hide')
            })
          } else if ((res.success = false)) {
            this.status = 'error'
            this.message = res.message
            this.helperFunctions.displayAlert(this.message, this.status)
          }
        },
        (err) => {
          this.loading = false
          if (err.status === 404) {
            this.message = 'Contact not found!'
          } else {
            this.message = 'Some error occurred. Please try again'
            this.status = 'error'
            this.helperFunctions.displayAlert(this.message, this.status)
            jQuery(document).ready(() => {
              this.isDeletingContact = false
              jQuery('#deleteSalesMngrModal').modal('hide')
            })
          }
        }
      )
  }

  onClickOutside() {
    jQuery(document).ready(() => {
      jQuery('#addContactModal').on('hidden.bs.modal', () => {
        this.closeAddContactModal()
      })
      jQuery('#addAgronomistModal').on('hidden.bs.modal', () => {
        this.closeAddAgroContactModal()
      })
      jQuery('#addSalesMngrModal').on('hidden.bs.modal', () => {
        this.closeAddSalesContactModal()
      })
      jQuery('#editSalesMngrModal').on('hidden.bs.modal', () => {
        this.closeEditSalesContactModal()
      })
    })
  }

  onDistrictOptionChosen(event) {
    this.districtPicked = event.target.value
    this.getSubcountySelectItems()
    this.addSalesMngr().controls = []
  }

  getSubcountySelectItems() {
    this.districtSubcountyData
      ? this.districtSubcountyData.map((each) => {
          let subCounties = []
          if (each.district === this.districtPicked) {
            each.subcounty
              ? each.subcounty.map((each) => {
                  subCounties.push({ label: each, value: each })
                  this.subcountiesToSelect = subCounties
                })
              : null
          }
        })
      : null
  }
}
